export default "__VITE_ASSET__ajf_n$dh__";